{
    "EmailRule_Failed": "L'e-mail deve essere valida",
    "NAME": "GenericRuleLanguage"
}